import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RemoveLuxuryHomesParams, RootState } from '@share/utils';
import { useQueryParams } from '@utils';
import { Routes } from '@share/constants';

import { LuxuryHomesProperties } from './properties/component';
import { LuxuryHomesMain } from '../commons/main/component';

import './style.scss';

export const LuxuryHomesList: React.FC = () => {
  const { location, checkIn, checkOut, guests } = useQueryParams();

  const { account } = useSelector((state: RootState) => state.loginStore);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!location && !checkIn && !checkOut && !guests) {
      RemoveLuxuryHomesParams();

      history.push(`/${account?.name}${Routes.LuxuryHomes}${location?.search}`);
    }
  }, [location, checkIn, checkOut, guests]);
  
  return (
    <LuxuryHomesMain 
      route={Routes.LuxuryHomes} 
      headerProps={{ fixed: true, className: 'luxury-homes-header__blue' }}
    >
      <LuxuryHomesProperties />
    </LuxuryHomesMain>
  );
};
